<script setup>
import {reactive,onMounted} from "vue";
import {ApiWrapper} from "@/Utils/ApiWrapper";
import {ToastUtil} from "@/Utils/ToastUtil";

const props = defineProps({
  contextSchemaA: String,
  contextSchemaB: String,
  contextIdA: String,
  contextIdB: String
});

const data = reactive({
  openClaims: '',
  cycle: '',
  name: '',
  phone: '',
  email: '',
  address: '',
});

const formatPhoneNumber = (phoneNumberString) => {
  let cleaned = ('' + phoneNumberString).replace(/\D/g, '')
  let match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/)
  if (match) {
    return '(' + match[1] + ') ' + match[2] + '-' + match[3]
  }
  return null
}

onMounted(()=>{

  let contextIdA = props.contextIdA;
  let contextIdB = props.contextIdB;
  if (contextIdA === null || contextIdB === null) {
    ApiWrapper.get('user-card', 'user-card')
    .then((response) => {
      if(response.person){
        data.name = response.person.name;
        data.phone = response.person.phone;
        data.email = response.person.email;
        data.address = response.person.streetaddress;
      }
    })
    .catch((e)=>{
      ToastUtil.error(e);
    });
  } else {
    ApiWrapper.get(
            'user-card',
            'pay-period-person','payPeriodId=' +
            contextIdA +
            '&personId=' +
            contextIdB
        )
        .then((response) => {
          if(response.person){
            data.name = response.person.name;
            data.phone = response.person.phone;
            data.email = response.person.email;
            data.address = response.person.streetaddress;
          }
        })
        .catch((e)=>{
          ToastUtil.error(e);
        });
  }
})
</script>

<template>
  <v-container fluid>
    <v-card class="elevation-2">
<!--      <v-img-->
<!--          src="https://cdn.vuetifyjs.com/images/lists/ali.png"-->
<!--          height="200"-->
<!--          dark-->
<!--      >-->
        <v-card-title>
          <div class="display-1">{{data.name}}</div>
        </v-card-title>
<!--      </v-img>-->
      <v-row>
        <v-col cols="1">
          <v-icon color="indigo" class="ml-5 mt-5">mdi-phone</v-icon>
        </v-col>
        <v-col cols="10">
          <v-list>
            <v-list-item>

                <v-list-item-title>{{formatPhoneNumber(data.phone) || "No phone number listed"}}</v-list-item-title>
                <v-list-item-subtitle>Mobile</v-list-item-subtitle>
            </v-list-item>

            <v-divider></v-divider>
          </v-list>
        </v-col>
        <v-col cols="1">
          <v-icon style="text-align: right" class="mt-5">mdi-message-text</v-icon>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="1">
          <v-icon color="indigo" class="ml-5 mt-5">mdi-email</v-icon>
        </v-col>
        <v-col cols="11">
          <v-list-item>
            <v-list-item-title>{{data.email}}</v-list-item-title>
            <v-list-item-subtitle class="ml-17">Email</v-list-item-subtitle>
          </v-list-item>

          <v-divider></v-divider>
        </v-col>
      </v-row>
      <v-row class="mb-5">
        <v-col cols="1">
          <v-icon color="indigo" class="ml-5 mt-5">mdi-map-marker</v-icon>
        </v-col>
        <v-col cols="11">
          <v-list-item>
            <v-list-item-title>{{data.address}}</v-list-item-title>
            <v-list-item-subtitle>Address</v-list-item-subtitle>
          </v-list-item>
        </v-col>
      </v-row>
    </v-card>
  </v-container>
</template>

<style scoped>
.container {
  padding: 5px;
}
[v-cloak] {
  display: none;
}
</style>